module.exports = __webpack_public_path__ + "img/obstacle-triggers.2cd5df73.png";